import { get } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const GetAllTerminalDef = () => get(url.TERMINAL_DEF_GET)